import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agrisActivity'
})
export class AgrisActivityPipe implements PipeTransform {

  transform(value: any, args?: string): any {
    if (!args) {
      return null;
    }

    switch (value) {
      case 64: // crear

        if (args === 'color') {
          return '#27db8f';
        } else if (args === 'icon') {
          return 'add'
        } else if (args === 'label') {
          return 'Creó la cotización'
        }
        break;

      case 65: // editar

        if (args === 'color') {
          return '#F29837';
        } else if (args === 'icon') {
          return 'edit'
        } else if (args === 'label') {
          return 'Editó la cotización'
        }
        break;

      case 66: // guardar

        if (args === 'color') {
          return '#2489b0';
        } else if (args === 'icon') {
          return 'save'
        } else if (args === 'label') {
          return 'Guardó la cotización'
        }
        break;

      case 67: // confirmar

        if (args === 'color') {
          return '#009451';
        } else if (args === 'icon') {
          return 'publish'
        } else if (args === 'label') {
          return 'Envió a JDE la cotización'
        }
        break;

      case 68: // perder

        if (args === 'color') {
          return '#ff4b5a';
        } else if (args === 'icon') {
          return 'cancel_schedule_send'
        } else if (args === 'label') {
          return 'Perdió la cotización'
        }
        break;

      case 69: // renovar

        if (args === 'color') {
          return '#8058bd';
        } else if (args === 'icon') {
          return 'schedule_send'
        } else if (args === 'label') {
          return 'Renovó la cotización'
        }
        break;

      case 70: // vencer

        if (args === 'color') {
          return '#ff7b8a';
        } else if (args === 'icon') {
          return 'event_busy'
        } else if (args === 'label') {
          return 'Venció la cotización'
        }
        break;

      default:

        if (args === 'color') {
          return '#6e6e6e';
        } else if (args === 'icon') {
          return 'help_outline'
        } else if (args === 'label') {
          return 'Acción no contemplada'
        }
        break;

    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-activity.pipe.ts